import { render, staticRenderFns } from "./ContentFavorites.vue?vue&type=template&id=64febc5d&scoped=true&shadow"
import script from "./ContentFavorites.vue?vue&type=script&lang=js&shadow"
export * from "./ContentFavorites.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./ContentFavorites.vue?vue&type=style&index=0&id=64febc5d&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "64febc5d",
  null
  ,true
)

export default component.exports